import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropAidState, CropAid, SkalTypeEnum } from '../crop-aid.model';

export const selectCropAidState = createFeatureSelector<CropAidState>('cropAid');

export const selectCropAids = createSelector(selectCropAidState, (state) => [
  ...(state.proprietaryCropAids || []),
  ...(state.genericCropAids || []),
]);

export const selectCropAid = (cropAidId: number) =>
  createSelector(selectCropAids, (cropAids: CropAid[]) =>
    cropAids.find((cropAid) => cropAid.id === cropAidId),
  );

export const selectOrganicCropAids = createSelector(selectCropAids, (cropAids: CropAid[]) =>
  cropAids.filter(
    (cropAid) =>
      cropAid.isFertilizer && cropAid.fertilizer && cropAid.fertilizer.skalType !== SkalTypeEnum.C,
  ),
);

export const selectAdmissions = createSelector(
  selectCropAidState,
  (state) => state.admissions || [],
);
